export type TNotification = {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  createdAt: string;
  read: boolean;
  sender: {
    id: string;
    name: string;
    avatar: string;
  };
};

export const MOCK_NOTIFICATION_DATA: TNotification[] = [
  {
    id: '1',
    message: 'You have a new message',
    type: 'success',
    createdAt: '2022-08-01T12:00:00.000Z',
    read: false,
    sender: {
      id: '1',
      name: 'John Doe',
      avatar: 'https://via.placeholder.com/150',
    },
  },
  {
    id: '2',
    message: 'This is a notification',
    type: 'success',
    createdAt: '2023-08-01T12:00:00.000Z',
    read: false,
    sender: {
      id: '1',
      name: 'John Doe',
      avatar: 'https://via.placeholder.com/150',
    },
  },
  {
    id: '3',
    message: 'You dont have a new message',
    type: 'success',
    createdAt: '2024-08-01T12:00:00.000Z',
    read: false,
    sender: {
      id: '1',
      name: 'John Doe',
      avatar: 'https://via.placeholder.com/150',
    },
  },
  {
    id: '4',
    message: 'You have a new message',
    type: 'success',
    createdAt: '2024-01-01T12:00:00.000Z',
    read: false,
    sender: {
      id: '1',
      name: 'John Doe',
      avatar: 'https://via.placeholder.com/150',
    },
  },
  {
    id: '5',
    message: 'You have a new message',
    type: 'success',
    createdAt: '2024-03-01T12:00:00.000Z',
    read: true,
    sender: {
      id: '1',
      name: 'John Doe',
      avatar: 'https://via.placeholder.com/150',
    },
  },
  {
    id: '6',
    message: 'You have a new message',
    type: 'success',
    createdAt: '2024-03-15T13:43:00.000Z',
    read: true,
    sender: {
      id: '1',
      name: 'John Doe',
      avatar: 'https://via.placeholder.com/150',
    },
  },
];
